module.exports = __webpack_public_path__ + "953169fe25f77a4b17905e1fea9f1954.svg";